import { ReactNode } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from "@libs/zapi-ui/ds/components/alert-dialog";

type TConfirmDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: ReactNode;
  description: ReactNode;
  confirmText?: ReactNode;
  cancelText?: ReactNode;
  confirmVariant?: "default" | "destructive";
  confirmStartAdornment?: ReactNode;
};

// The design system's confirmation, for parts rebuilt on the design system.
export function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmVariant = "destructive",
  confirmStartAdornment,
}: TConfirmDialogProps) {
  return (
    <AlertDialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <AlertDialogContent
        data-testid="confirmation-modal"
        onClick={(event) => event.stopPropagation()}
      >
        <AlertDialogHeader>
          <AlertDialogTitle data-testid="confirmation-modal-title">{title}</AlertDialogTitle>
          <AlertDialogDescription data-testid="confirmation-modal-description">{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="cancel-button">{cancelText}</AlertDialogCancel>
          <AlertDialogAction
            variant={confirmVariant}
            data-testid="confirm-button"
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            {confirmStartAdornment}
            {confirmText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
